import React from 'react'
import "./HowTo.scss"
import { track } from "../analytics/meta";

export default function HowTo() {
  const array = [
    {
      color: "#ED484A",
      title: "Crea tu perfil",
      description: "Contanos quién eres y qué te representa",
      icon: "/iconos/user.png",
      number: "01"
    },
    {
      color: "#45A55A",
      title: "Descubre personas afines",
      description: "Nuestro algoritmo te conecta con quienes comparten tu cultura",
      icon: "/iconos/teamwork.png",
      number: "02"
    },
    {
      color: "#9E81BA",
      title: "Conecta con personas que vibran como vos",
      description: "Inicia conversaciones auténticas y construye relaciones significativas",
      icon: "/iconos/heart.png",
      number: "03"
    },
  ]
  return (
    <div className='how-to' id='como-funciona'>
      <img src="/elementos-graficos/RECURSOS KUSKA -36.png" className='decoration-1' alt="Elementos grafico Kuska 1" />
      <img src="/elementos-graficos/RECURSOS KUSKA -42.png" className='decoration-2' alt="Elementos grafico Kuska 2" />
      <h1 className='text-center section-title'>Cómo funciona</h1>
      <p className='subtitle text-center mb-5'>Tres pasos simples para encontrar tu conexión</p>
      <div className='row row-cols-1 row-cols-lg-3 g-4'>
        {
          array.map(item=>(
            <div>
              <div className='card-2'>
                <p className='card-number' style={{color: item.color}}>{item.number}</p>
                <span className='icon' style={{backgroundColor: item.color}}>
                  <img src={item.icon} alt={item.title} />
                </span>
                <p className='title'>{item.title}</p>
                <p className='description'>{item.description}</p>
              </div>
            </div>
          ))
        }
      </div>
      <div className='d-flex flex-lg-row flex-column justify-content-center'>
        <a 
          href="https://play.google.com/store/apps/details?id=com.kuska.kuskapp" 
          className='btn-download btn-play-store me-0 me-lg-4'
          onClick={() => track("DownloadPlayStore", { source: "home_howto" })}  
        >Descargar - Play Store
        </a>
        <p 
          className='btn-download btn-app-store'
        >Próximamente - App Store
        </p>
      </div>
    </div>
  )
}
